import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';

/**
 * Маршрутын түвшний алдааны хуудас (React Router `errorElement`).
 * Ямар нэг хуудас render хийх үедээ унавал бүх апп цагаан болохын оронд
 * найрсаг мэдээлэл + сэргээх товчнуудыг харуулна.
 */
export function RouteErrorPage() {
  const err = useRouteError();
  const navigate = useNavigate();

  let title = 'Алдаа гарлаа';
  let detail = 'Хуудсыг харуулах явцад гэнэтийн алдаа гарлаа.';
  if (isRouteErrorResponse(err)) {
    if (err.status === 404) {
      title = 'Хуудас олдсонгүй';
      detail = 'Таны хайсан хуудас байхгүй эсвэл шилжсэн байна.';
    } else {
      title = `Алдаа ${err.status}`;
      detail = err.statusText || detail;
    }
  }
  const message = err instanceof Error ? err.message : null;

  return (
    <div className="ts-route-error fade-in" role="alert">
      <div className="ts-route-error-card">
        <span className="ts-empty-icon ts-route-error-icon" aria-hidden="true">
          <i className="bi bi-exclamation-octagon" />
        </span>
        <h1 className="ts-route-error-title">{title}</h1>
        <p className="ts-route-error-desc">{detail}</p>
        {message ? <pre className="ts-route-error-msg">{message}</pre> : null}
        <div className="ts-empty-actions">
          <button type="button" className="ts-btn-primary" onClick={() => location.reload()}>
            <i className="bi bi-arrow-clockwise" /> Дахин ачаалах
          </button>
          <button type="button" className="ts-btn-outline" onClick={() => navigate(-1)}>
            <i className="bi bi-arrow-left" /> Буцах
          </button>
        </div>
        <p className="ts-route-error-hint">
          Асуудал давтагдвал дэлгэцийн зургийг аваад дэмжлэгийн багт илгээнэ үү.
        </p>
      </div>
    </div>
  );
}
